import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-263">
      <div className="max-w-3xl mx-auto text-center" data-id="element-264">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6" data-id="element-265">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <p className="text-gray-300 text-lg sm:text-xl mb-4 leading-relaxed" data-id="element-266">
          Amás el Pilates, pero terminás los domingos armando clases a las 11 de
          la noche con material que "más o menos sirve".
        </p>

        <p className="text-[#A855F7] text-xl sm:text-2xl font-black mb-10" data-id="element-267">
          No es falta de vocación. Es falta de un sistema.
        </p>

        <div className="space-y-4 text-left mb-12" data-id="element-268">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-269">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-270">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-271">
              Domingo planificando clases cuando podrías estar descansando o
              disfrutando
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-272">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-273">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-274">
              Alumnos que se van porque no ven progreso — y vos sin herramientas
              para mostrárselo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-275">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-276">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-277">
              Clases grupales que se sienten caóticas porque no tenés la
              estructura correcta
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-278">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-279">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-280">
              Alumnos con hernias, escoliosis o embarazo que llegan y no sabés
              cómo adaptar
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-281">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-282">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-283">
              Agenda con huecos porque no tenés sistema de confirmación ni
              política de cancelaciones
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-284">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-285">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-286">
              Cobrando lo mismo que hace 2 años sin saber cómo justificar un
              aumento
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-287">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-288">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-289">
              Fin de semana agotado — el domingo volvés a empezar el mismo ciclo
            </p>
          </div>
        </div>

        <p className="text-[#A855F7] text-2xl sm:text-3xl font-black mb-8 italic" data-id="element-290">
          ¿Y si este fuera el último domingo que pasás así?
        </p>

        {/* Purple divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#A855F7] to-transparent w-full" data-id="element-291" />
      </div>
    </section>;
}